export var pages = {
    landOwnership: {
        'title': 'Do you own the land',
        'questions': ['landOwnership'],
        'visible': true // ['equal', 'property', 'mobileHome']
    },
    borrowerName: {
        'title': 'Please enter your name below',
        'subtext': 'Your privacy is protected.',
        'questions': ['firstName', 'lastName']
    },
    loanPurpose: {
        'title': 'Hi, are you buying or refinancing?',
        'questions': ['loanPurpose']
    },
    emailAndPhone: {
        'title': 'Thanks!<br>I just need one last thing',
        'subtext': 'We adhere to a strict privacy policy and will never sell your information.',
        'questions': ['email', 'phone']
    },
    phone: {
        'title': 'What\'s your phone number?',
        'subtext': 'We adhere to a strict privacy policy and will never sell your information.',
        'questions': ['phone']
    },
    propertyType: {
        'title': 'What type of property are you purchasing?',
        'questions': ['propertyType']
    },
    propertyTypeR: {
        'title': 'What type of property are you refinancing?',
        'questions': ['propertyType']
    },
    refinanceReason: {
        'title': 'Why do you want to refinance?',
        'questions': ['refinanceReason']
    },
    homeValue: {
        'title': 'We\'re almost there!<br/>What\'s your home\'s value?',
        'subtext': 'Just an estimate is fine. You can update the amount later in the process.',
        'questions': ['homeValue']
    },
    refinLoanAmount: {
        'title': 'How much do you owe?',
        'subtext': 'Just an estimate is fine. You can update the amount later in the process.',
        'questions': ['mortgageBalance']
    },
    cashoutAmount: {
        'title': 'How much cash do you want to borrow?',
        'subtext': 'Just an estimate is fine. You can update the amount later in the process.',
        'questions': ['cashoutAmount']
    },
    fhaLoan: {
        'title': 'Do you currently have FHA loan?',
        'questions': ['fhaLoan']
    },
    foreclosure: {
        'title': 'Any foreclosure in the past 2 years?',
        'questions': ['foreclosure']
    },
    militaryService: {
        'title': 'Active or previous military service?',
        'questions': ['militaryService']
    },
    propertyState: {
        'title': 'Where\'s the property located?',
        'subtext': 'We\'ll get local information for you.',
        'questions': ['propertyState']
    },
    firstTimeBuyer: {
        'title': 'Is this your first time buying a home?',
        'questions': ['firstTimeBuyer']
    },
    timeFrame: {
        'title': 'When do you plan to purchase?',
        'questions': ['timeFrame']
    },
    downPayment: {
        'title': 'How much will your down payment be?',
        'subtext': 'Just an estimate is fine. You can update the amount later in the process.',
        'questions': ['downPayment']
    },
    hearAboutUs: {
        'title': 'How did you hear about us?',
        'questions': ['hearAboutUs']
    },
    purchasePrice: {
        'title': 'We\'re almost there!<br/>What\'s the estimated purchase price?',
        'subtext': 'Just an estimate is fine. You can update the amount later in the process.',
        'questions': ['purchasePrice']
    },
    bankruptcy: {
        'title': 'Any bankruptcy in the past 3 years?',
        'questions': ['bankruptcy']
    },
    income: {
        'title': 'What is your gross annual household income?',
        'questions': ['income']
    },
    incomeProof: {
        'title': 'Can you show proof of income?',
        'questions': ['incomeProof']
    },
    lateMortgagePayments: {
        'title': 'Number of late mortgage payments in the last 12 months?',
        'questions': ['lateMortgagePayments']
    },
    employment: {
        'title': 'Are you currently employed?',
        'questions': ['employment']
    },
    creditRating: {
        'title': 'How would you rate your credit?',
        'subtext': 'Finding your custom rate quote will not affect your credit.',
        'questions': ['creditRating'
        ]
    },
    email: {
        'questions': ['email'],
        'title': 'What is your email address?',
        'subtext': 'We adhere to a strict privacy policy and will never sell your information.'
    },
    occupancy: {
        'title': 'How will your property be used?',
        'questions': ['occupancy']
    },
    hasAgent: {
        'title': 'Are you working with a real estate agent?',
        'questions': ['hasAgent']
    }
};
